<template>
  <layout>
    <page-header :header="$t('managers.add_new')" />
    <div class="content">
      <resource-form @saved="returnBack" @cancelled="returnBack" />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'managers'

export default {
  name: 'ManagersCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
